import React from 'react';
import './DoctorProfile.css';

import { Link } from "react-router-dom"

const DoctorProfile = () => {
  return (
    <div className="doctor-profile">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-overlay"></div>
        <div className="container hero-content">
          <h1>Dr. Sunil Apsingi</h1>
          <p className="qualification">MS (PGI, Chandigarh)</p>
          <p className="role">Chief Arthroscopy & Joint Replacement Surgeon</p>
        </div>
      </div>

      <div className="container content-wrapper">
        <div className="row">
          
          {/* Main Profile Card (Floating) */}
          <div className="col-12">
            <div className="card profile-card main-info">
              <div className="card-body p-0">
                <div className="row g-0 align-items-center">
                  <div className="col-md-4 col-lg-3 text-center p-4">
                    <img
                      alt="Dr. Sunil Apsingi"
                      className="profile-image"
                      src="images/2022-05-13.png"
                    />
                  </div>
                  <div className="col-md-8 col-lg-9 p-4">
                    <div className="d-flex flex-wrap gap-2 mb-3">
                      <span className="badge-custom badge-experience">22+ Years Experience</span>
                      <span className="badge-custom badge-time">Available: 10 AM - 4 PM</span>
                    </div>
                    
                    <div className="contact-details">
                      <div className="contact-item">
                        <span className="icon-circle">📍</span>
                        <span>Medicover Out Patient Center, HUDA Techno Enclave, HITEC City, Hyderabad, Telangana 500081</span>
                      </div>
                      <div className="contact-item">
                        <span className="icon-circle">📞</span>
                        <span>040-68334455</span>
                      </div>
                    </div>

                    <div className="mt-4">
                      <Link className="btn btn-primary-custom me-3" to="/bookappointment">Book Appointment</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Left Column: Languages & Quick Info */}
          <div className="col-lg-4 mt-4">
            <div className="card profile-card h-100">
              <div className="card-header-custom">
                <h3>Languages Spoken</h3>
              </div>
              <div className="card-body">
                <ul className="language-list">
                  {["English", "తెలుగు (Telugu)", "हिन्दी (Hindi)", "मराठी (Marathi)"].map((lang, index) => (
                    <li key={index}>
                      <span className="check-icon">✓</span> {lang}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Right Column: Expertise */}
          <div className="col-lg-8 mt-4">
            <div className="card profile-card h-100">
              <div className="card-header-custom">
                <h3>Surgical Expertise</h3>
              </div>
              <div className="card-body">
                <div className="expertise-wrapper">
                  {[
                    "Arthoscopy Knee", "Arthoscopy Shoulder", "Knee Replacement",
                    "Shoulder Replacement", "ACL Reconstruction", "Meniscal Repair",
                    "Rotator Cuff Repair", "Bankart Surgery", "Ligament Reconstruction",
                    "High Tibial Osteotomy", "Revision Knee Replacement", "Revision ACL",
                    "Trauma Surgery", "Complex Arthoscopy"
                  ].map((item, index) => (
                    <span key={index} className="expertise-pill">
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Section: Publications */}
          <div className="col-12 mt-4 mb-5">
            <div className="card profile-card">
              <div className="card-header-custom">
                <h3>Research & Publications</h3>
              </div>
              <div className="card-body">
                <ul className="publications-list">
                  {[
                    "Dynamic nature of alignment and variations in normal knees. K Deep, KK Eachempati. Accepted for publication BJJ, 2014.",
                    "Review: femoral tunnel placement for PCL reconstruction in relation to the PCL fibre bundle attachments. Knee Surg Sports Traumatol Arthrosc. 2009.",
                    "Sudden loss of visual acuity following intra-articular steroid injection to the knee joint: a case report. Cases J. 2008.",
                    "The role of PCL reconstruction in knees with combined PCL and posterolateral corner deficiency. Knee Surg Sports Traumatol Arthrosc. 2008.",
                    "Control of laxity in knees with combined posterior cruciate ligament and posterolateral corner deficiency. Am J Sports Med 2008."
                  ].map((item, index) => (
                    <li key={index} className="publication-item">
                      <span className="pub-number">{index + 1}</span>
                      <p>{item}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default DoctorProfile;